/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import PropTypes from "prop-types";
import { styled } from "@mui/material";
import { t } from "i18next";

function StrategicAnalysisDesktop({ config }) {
  return (
    <iframe
      width={"100%"}
      height={"100%"}
      src="https://mtrix-padsales-main.mtrix.com.br"
    ></iframe>
  );
}

StrategicAnalysisDesktop.defaultProps = {
  app: null,
  config: {},
};

StrategicAnalysisDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default StrategicAnalysisDesktop;
